import {
  getChatbotBuilderUrl,
  getEditZapUrl,
  getInterfaceBuilderUrl,
  getTableBuilderUrl,
} from "@zapier/utils";

import ResourceCard from "./ResourceCard";
import { ZslApiTemplateExecuteOutput } from "@zapier/bff";

interface TemplateCreationScreenProps {
  createdTemplate: ZslApiTemplateExecuteOutput;
}

const CreatedResources = ({ createdTemplate }: TemplateCreationScreenProps) => {
  return (
    <>
      {Object.keys(createdTemplate?.chatbots).map((id) => {
        const name = createdTemplate.chatbots[id]?.config.chatbotName;

        return (
          <ResourceCard
            key={id}
            kind="chatbot"
            href={getChatbotBuilderUrl(id)}
            name={name}
          />
        );
      })}
      {Object.keys(createdTemplate?.zaps).map((id) => {
        const { title } = createdTemplate.zaps[id];

        return (
          <ResourceCard
            key={id}
            kind="zap"
            href={getEditZapUrl(id.toLowerCase())}
            name={title}
          />
        );
      })}
      {Object.keys(createdTemplate?.tables).map((id) => {
        const { name } = createdTemplate.tables[id];

        return (
          <ResourceCard
            key={id}
            kind="table"
            href={getTableBuilderUrl(id)}
            name={name}
          />
        );
      })}
      {Object.keys(createdTemplate?.interfaces).map((id) => {
        const { name } = createdTemplate.interfaces[id];

        return (
          <ResourceCard
            key={id}
            kind="interface"
            href={getInterfaceBuilderUrl(id.toLowerCase())}
            name={name}
          />
        );
      })}
      {Object.keys(createdTemplate?.canvases).map((id) => {
        const { name } = createdTemplate.canvases[id];

        return (
          <ResourceCard
            key={id}
            kind="canvas"
            href={`/app/canvas/${id}`}
            name={name}
          />
        );
      })}
    </>
  );
};

export default CreatedResources;
